import { render } from "./BrowseView.vue?vue&type=template&id=15491d72&scoped=true"
import script from "./BrowseView.vue?vue&type=script&lang=js"
export * from "./BrowseView.vue?vue&type=script&lang=js"

import "./BrowseView.vue?vue&type=style&index=0&id=15491d72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15491d72"]])

export default __exports__